"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (fn, interfaces) {
	return Object.keys(interfaces).reduce(function (obj, method) {
		return _extends({}, obj, _defineProperty({}, method, function (name, token, opts) {
			fn(name, token, _extends({}, interfaces[method], {
				options: opts
			}));
		}));
	}, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/bind-interface.js
// module id = 234
// module chunks = 0